import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../app/utils/alert.service';
import { AuthenticationService } from '../../../../app/services/authentication.service';
import { BindComponentService } from '../../../../app/utils/bind.component.service';
import { DataPackGroup } from '../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../app/models/dataPackLine.model';
import { ConfigureBlockingModalComponent } from '../../../../app/home/paraEmpresas/block/configure/content.component';

  import * as _ from "lodash";

/**
 * @version $Id: content.component.ts 81709 2018-03-09 04:19:01Z thiago.h.neri $
 */
@Component({
  selector: 'block',
  templateUrl: './content.template.html'
})

export class BlockComponent implements OnInit {

  static BLOQUEIO_VOZ = 'BLOQUEIO_VOZ';
  static BLOQUEIO_DADOS = 'BLOQUEIO_DADOS';
  static BLOQUEIO_VIVO_UP ='BLOQUEIO_VIVO_UP';

  public linkAtual: string;
  public isVoiceBlock: boolean = true;
  public isVivoUp: boolean = false;
  
  public hasData: boolean = false;
  public totalGroups: number;
  private loggedManagerType: string;

  constructor(private bindComponent: BindComponentService, private authenticationService: AuthenticationService, private alertService: AlertService) {

  }

  ngOnInit() {
    setTimeout(() => {
        document.getElementById('voiceBlock').classList.add('active');
        let data  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
        this.loggedManagerType = data['loggedManagerType'];
        this.hasData = data['isData'];
        if (!this.hasData) {
          document.getElementById('dataBlock').classList.add('inactive');
        }
        if(this.loggedManagerType === 'GROUP_MANAGER'){
          document.getElementById('dataVivoUpBlock').classList.add('inactive');
        }
        this.bindComponent.subscribe(BindComponentService.TOTAL_GROUPS,
          total => {
            this.totalGroups = total;
          }
        );
    }, 50);   
  }

  public redirecionarBloqueio(link: string) {
    if (BlockComponent.BLOQUEIO_VOZ === link) {
      this.isVoiceBlock = true;
      document.getElementById('voiceBlock').classList.add('active');
      document.getElementById('dataBlock').classList.remove('active');
      document.getElementById('dataVivoUpBlock').classList.remove('active');
      this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_VOICE, false);
    } else if (BlockComponent.BLOQUEIO_DADOS === link) {
      this.isVoiceBlock = false;
      this.isVivoUp = false;
      document.getElementById('dataVivoUpBlock').classList.remove('active');
      document.getElementById('voiceBlock').classList.remove('active');
      document.getElementById('dataBlock').classList.add('active');
      this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_VOICE, false);
    }else if (BlockComponent.BLOQUEIO_VIVO_UP === link) {
      this.isVivoUp = true;
      this.isVoiceBlock = false;
      document.getElementById('voiceBlock').classList.remove('active');
      document.getElementById('dataBlock').classList.remove('active');
      document.getElementById('dataVivoUpBlock').classList.add('active');
      this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_VOICE, false);
    }else {
      this.isVoiceBlock = true;
    }
  }

  public isGestorCompany():boolean{
    let authenticatedUser  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    if(!_.isNil(authenticatedUser)){
      this.loggedManagerType = authenticatedUser['loggedManagerType'];
      if (this.loggedManagerType === 'COMPANY_MANAGER' || this.loggedManagerType === 'COMPANY_MASTER_MANAGER') {
        return  authenticatedUser['showB2B2CFuncionality'];
      } else {
        return false;
      }
    }  
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/content.component.ts